import { ISchedule } from '../schedule';
import {
  ISession,
  SingleCommunication,
  MultipleCommunications,
  AppSettings
} from '../session';

export enum TimeOfDay {
  A = 'A',
  E = 'E',
  X = 'X',
  L = 'L',
  M = 'M'
}

interface IEpxEndodbScheduleConfig {
  [x: string]: {
    pre: boolean;
    post: boolean;
  };
}

export interface IEpxEndodbSchedule extends ISchedule {
  config?: IEpxEndodbScheduleConfig;
}

export interface IEpxEndodb extends ISession, SingleCommunication {
  bsBefore?: number;
  bsAfter?: number;
  insulin?: number;
  timeOfDay?:
    TimeOfDay.A | TimeOfDay.E | TimeOfDay.X | TimeOfDay.L | TimeOfDay.M;
}

export interface IEpxEndodbMeta extends ISession, MultipleCommunications {
  tz?: string;
  [TimeOfDay.A]?: IEpxEndodb;
  [TimeOfDay.E]?: IEpxEndodb;
  [TimeOfDay.M]?: IEpxEndodb;
  [TimeOfDay.L]?: IEpxEndodb;
  [TimeOfDay.X]?: Array<IEpxEndodb>;
}

export interface IEpxEndodbSettings extends AppSettings {
  postprandialAlert?: boolean;
  thresholds?: {
    red?: {
      fasting?: {
        avg?: number;
        max?: number;
        min?: number;
      };
    };
    yellow?: {
      fasting?: {
        avg?: number;
      };
    };
  };
}
